/* Aggiunta di layer tramite Url */

import { useLeaflet } from "react-leaflet";
import { useEffect } from "react";
import { connect } from "react-redux";
import * as WMS from "leaflet.wms";
import L from 'leaflet'
import axios from 'axios'


const AddLayerUrl = (props) => {
    const { map } = useLeaflet();


    function addLayer(url,nome){
        const options = {
            "version": "1.1.0",
            "format": "image/png",
            "transparent": "true", 
            "info_format": "application/json",
            fetchOptions: {headers: window.tp_headers}
        }
        // Add WMS source/layers
        const source = WMS.source(
            url,
            options
        );
        source.getLayer(nome).addTo(map)
    }

    function LoadGeoJSON(layer,flag,nome){
        
        try {
            const a = L.geoJSON(layer, {
                tag : nome
                // style: function (feature) {
                    
                //     return {radius: 8, fillColor: "#cc9200", color: "#000000", weight: 1, opacity: 1, fillOpacity: 1};
                // }
            })
            
            flag ? map.addLayer(a) : map.removeLayer(a)
        } catch (error) {
            
        }
    }

    const addLayerWFS = (url,nome)=>{
        const GEOSERVER = url;

        const REQUEST_PARAMS = {
            outputFormat: 'application/json',
            maxFeatures: 250,
            request: 'GetFeature',
            service: 'WFS',
            typeName: nome,
            version: '1.0.0'
        };
        
        
        axios.get(GEOSERVER, { params: REQUEST_PARAMS, headers: window.tp_headers})
        .then(({ data }) => LoadGeoJSON(data,true,nome))
        .catch(error => Promise.reject(error))
    }
    const removeLayerWFS = (url,nome)=>{
        map.eachLayer(element => {
            if ( element.options.tag === nome) {
                try { 
                    map.removeLayer(element)
                }
                catch(e) {}
            }
        }); 
    }

    function removeLayer(url,nome){
        map.eachLayer(element => {
            if ( element._name === nome) {
              try { 
                map.removeLayer(element)
                }
                catch(e) {}
            }
        }); 
    }
    function removeAllLayer(){
        map.eachLayer(element => {
           
              try { 
                //map.removeLayer(element)
                if(element._source !== undefined){
                   

                    map.removeLayer(element)

                }
                }
                catch(e) {}
            
        }); 
    }



    useEffect(()=>{
       
        try {
            if(props.layerUrl.name === null &&  props.layerUrl.check === null){
                
                removeAllLayer()
    
            }else{
            const url = props.layerUrl.url
            const nome = props.layerUrl.name
            if (props.typeLayer.typeLayer==='WMS'){
                props.layerUrl.check ? addLayer(url,nome) : removeLayer(url,nome)
            }else if (props.typeLayer.typeLayer==='WFS'){
                props.layerUrl.check ? addLayerWFS(url,nome) : removeLayerWFS(url,nome)
            }
            
        }} catch (error) {
            
        }

    },[props.layerUrl])
   
    return null;
};

const mapStateToProps = state => {
    return {
        layerUrl: state.layerUrl.layerUrl,
        typeLayer: state.typeLayer
    }
  }
export default connect(mapStateToProps)(AddLayerUrl);